'use client';

import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip"
import { Provider } from "react-redux";
import { store } from "@/app/store/store";
import type { User } from "@/libraries/defenitions";
import { useDispatch } from "react-redux";
import { addUserInfo, setToken } from "@/app/store/features/userSlice";
import { useEffect } from "react";

export function AppProviders({ children, user, token }: { children: React.ReactNode, user: User | null, token: string | null }) {

  return (
    <Provider store={store}>
      <InitUser user={user} token={token} />
      <Toaster
        position="top-right"
        richColors={true}
        closeButton={true}
        toastOptions={{
          classNames: {
            toast: "toast",
            title: "title",
            description: "description",
            actionButton: "action-button",
            cancelButton: "cancel-button",
            closeButton: "close-button !left-auto !right-[-14] !bg-white",
          },
        }}
      />
      <TooltipProvider>
        {children}
      </TooltipProvider>
    </Provider>
  );
}

function InitUser({ user, token }: { user: User | null, token: string | null }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      dispatch(addUserInfo(user));
    }
    if (token) {
      dispatch(setToken(token));
    }
  }, [user, token, dispatch]);

  return null;
}